import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperLocationComponent: {
      height: "1093.75146484375px",
      width: "100%",
    },
  };
});
